// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"563":"ff1be22b","778":"64437862"}[chunkId] + ".chunk.js";
};